export function getToken() { return localStorage.getItem('charth_token'); }
export function getUser()  { try { return JSON.parse(localStorage.getItem('charth_user')); } catch { return null; } }
export function setSession(token, user) {
  localStorage.setItem('charth_token', token);
  localStorage.setItem('charth_user', JSON.stringify(user));
}
export function clearSession() {
  localStorage.removeItem('charth_token');
  localStorage.removeItem('charth_user');
}
export function isLoggedIn() { return !!getToken(); }

export const ROLE_LABELS = {
  admin:   'Administrador',
  buyer:   'Comprador',
  analyst: 'Analista',
  viewer:  'Visualizador',
  agent:   'Agente',
};

export const ROLE_COLORS = {
  admin:   '#C0392B',
  buyer:   '#E8A020',
  analyst: '#2E5B8A',
  viewer:  '#8898AA',
};

export function can(user, permission) {
  const PERMISSIONS = {
    admin:   ['read','write','delete','manage_users','manage_settings','reports','edit_dates'],
    buyer:   ['read','write','delete','reports','edit_dates'],
    analyst: ['read','write_own','reports'],
    viewer:  ['read','reports'],
  };
  return (PERMISSIONS[user?.role] || []).includes(permission);
}
